/**
 * @generated SignedSource<<24d9b1cb61b64d01e9996baf406cc0c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchList$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ListItemsPaginated_results">;
  readonly " $fragmentType": "SearchList";
};
export type SearchList$key = {
  readonly " $data"?: SearchList$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchRepository"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "labelPageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "showIssueFieldPills"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    },
    {
      "defaultValue": "ISSUE_ADVANCED",
      "kind": "LocalArgument",
      "name": "type"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchList",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRepository",
          "variableName": "fetchRepository"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "labelPageSize",
          "variableName": "labelPageSize"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        },
        {
          "kind": "Variable",
          "name": "showIssueFieldPills",
          "variableName": "showIssueFieldPills"
        },
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        },
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "type"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ListItemsPaginated_results"
    }
  ],
  "type": "Searchable",
  "abstractKey": "__isSearchable"
};

(node as any).hash = "6c7e4f2d5a4b8644d56e9dbdd98d7fa4";

export default node;
